import API from '../../../api.js'
let sensitiveWordLists=[]
/**
 * 检测文本是否包含敏感词
 * @param {String} text 要检测的内容
 * @returns {Object} { isSensitive: 是否敏感, word: 命中的敏感词 }
 */
export function checkSensitiveWord(text, courseClassId, studentInfo) {
	if (!text || text.trim() === '') {
		return {
			isSensitive: false,
			word: ''
		}
	}

	// 🔥 关键：移除【所有空格】（包括中间、首尾、全角空格）
	let content = text.replace(/\s+/g, '').toLowerCase()

	let hitWord = ''
	let isHit = false

	for (const word of sensitiveWordLists) {
		if (content.includes(word.toLowerCase())) {
			isHit = true
			hitWord = word
			forPostStudentChat(word, text, courseClassId, studentInfo)
			break
		}
	}

	// 返回完整结果
	return {
		isSensitive: isHit,
		word: hitWord
	}
}
export async function adminMonitorWork() {
	sensitiveWordLists=[]
	//标准中台
	try {
		const res = await API.get(API.fileurl.getAllWords, {
			orgId: 0,
			platformFlag: 1
		});
		
		sensitiveWordLists.push(...res.data)
		const ress=await API.get(API.fileurl.getAllWords, {
			orgId: localStorage.getItem('orgId'),
			platformFlag:2
		});
		if(ress.data){
			sensitiveWordLists.push(...ress.data)
		}
		
	} catch (error) {

	}
}
export async function forPostStudentChat(word, text, courseClassId, student) {
	console.log('student', student)
	let studentInfo = JSON.parse(student)
	console.log('studentInfo', studentInfo)
	try {
		const res = await API.post(API.student.postStudentSensitive, {
			"classId": studentInfo.classId,
			"schoolId": studentInfo.schoolId,
			"courseId": courseClassId,
			"studentId": studentInfo.id,
			"sensitiveWord": word,
			"sendContent": text

		});
		return true
	} catch (e) {
		return false
	}
}